import { concat, filter, find, flatten, has, isArray, map } from "lodash";

import { BATCH } from "./chainActionTypes";
// import { batchActions } from "./chainReducer";

const isBatchAction = action => action.type === BATCH;

const createBatchAction = (actions, skipFlatten = false) => {
  const b = {
    type: BATCH,
    actions: filter(actions, a => a)
  };

  return skipFlatten ? b : flattenBatchedActions(b);
};

const batchWithAppendedActions = (batch, actions) => {
  return createBatchAction(flatten(concat(batch.actions ? batch.actions : batch, actions)));
};

// Find the first action object of the provided type in the batch
// Be cautious when using this in validationChecks, as it may mean we miss out on the rest of the actions
const findActionOfType = (action, actionType) =>
  action.type == actionType ? action : find(action.actions, a => a.type === actionType);

// Find the first action object of the provided types in the batch
// Be cautious when using this in validationChecks, as it may mean we miss out on the rest of the actions
const findActionOfTypes = (action, actionTypes) =>
  actionTypes.indexOf(action.type) >= 0 ? action : find(action.actions, a => actionTypes.indexOf(a.type) >= 0);

const findActionsOfType = (action, actionType) => findActionsOfTypes(action, [actionType]);

const findActionsOfTypes = (action, actionTypes) =>
  actionTypes.indexOf(action.type) >= 0 ? [action] : filter(action.actions, a => actionTypes.indexOf(a.type) >= 0);

const nestedActionsInBatch = action =>
  action.actions ? flatten(map(action.actions, a => nestedActionsInBatch(a))) : [action];

const flattenBatchedActions = actions => {
  const allActions = isArray(actions)
    ? flatten(map(actions, a => nestedActionsInBatch(a)))
    : nestedActionsInBatch(actions);
  return createBatchAction(allActions, true);
};

const findActionWithKey = (action, key) => (has(action, key) ? action : find(action.actions, a => has(a, key)));

const findActionValue = (action, key) => {
  const a = findActionWithKey(action, key);
  if (a) {
    return a[key];
  }
  return null;
};

export default {
  isBatchAction,
  createBatchAction,
  batchWithAppendedActions,
  findActionOfType,
  findActionOfTypes,
  findActionsOfType,
  findActionsOfTypes,
  flattenBatchedActions,
  nestedActionsInBatch,
  findActionWithKey,
  findActionValue
};
